export enum LibraryType {
    PDF = "pdf",
    AUDIO = "audio",
    VIDEO = "video",
    COURSE = "course",
    EMBED = "embed",
    ARTICLE = "article",
}

export enum LibraryAccess {
    PAID = "paid",
    FREE = "free",
    PRICED = "priced",
    PLAN = "plan",
    SEGMENT = "segment",
}

export type LibraryItem = {
    type: LibraryType;
    title: string;
    summary: string;
    description: string;
    description_json?: string | null;
    access: LibraryAccess;
    content_url: string;
    original_file_name: string;
    file_size: number;
    storage_id: string;
    discussion: boolean;
    downloadable: boolean;
    requires_moderation: boolean;
    thumbnail_image?: string | null;
    slug: string;
    plan_ids: Array<any>;
    segment_ids: Array<any>;
    currency?: string;
    visibility: ContentVisibility;
    price: any;
    display_authorized_plans: boolean;
    lock_screen_active: boolean;
    lock_screen_btn_label: string;
    lock_screen_btn_url: string;
    lock_screen_instructions: string;
    post_title_required: boolean;
    disable_comments_and_reactions: boolean;
    cover_image_required: boolean;
}

export enum ContentType {
    PDF= "pdfs",
    AUDIO = "audios",
    VIDEO = "videos",
    COURSE = "courses",
    EMBED = "embeds",
    ARTICLE = "articles",
    CATEGORY = "category"
}

export enum ContentVisibility {
    COMMUNITY = "member",
    PUBLIC = "public",
    RESTRICTED = "restricted",
}

export enum LibraryTabs {
    DETAILS = "Details",
    MEMBERS = "Members",
    PRICING = "Pricing",
}

export enum UploadTypes {
    IMAGE = 'image',
    VIDEO = 'video',
    ATTACHMENT = 'attachment',
    PDF = 'pdf',
    AUDIO = 'audio',
    VIDEO_LINK = 'video',
}
// The course type, fixed at creation.
export enum CourseType {
    SELF_PACED = "self_paced",
    COHORT = "cohort",
}

// Whether a course (or the library row wrapping one) is a cohort course.
export const isCohortCourse = (course: any) => {
    const content = course && course.contentable ? course.contentable : course;
    return !!(content && content.type === CourseType.COHORT);
};

// The ?type= value the list page passes so the editor opens on the right tab.
export const courseTypeParam = (course: any) =>
    isCohortCourse(course) ? CourseType.COHORT : CourseType.SELF_PACED;
